// StyledCheckbox.tsx
import { styled } from '@mui/material/styles'
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox'
import Checked from '../../../assets/images/icons/cheked_icon.svg?react'
import Unchecked from '../../../assets/images/icons/unchecked_icon_light.svg?react'

export const StyledCheckbox = styled((props: CheckboxProps) => (
  <Checkbox
    icon={<Unchecked />}
    checkedIcon={<Checked />}
    indeterminateIcon={<IndeterminateCheckBoxIcon color="primary" fontSize="small" />}
    disableRipple
    {...props}
  />
))(({ theme, disabled }) => ({
  height: theme.spacing(4.25),
  width: theme.spacing(4.25),
  '&:hover': {
    opacity: 0.5,
    '& svg path:first-of-type': {
      stroke: '#000000',
    },
  },
  ...(disabled && {
    cursor: 'not-allowed',
    '& svg rect': {
      fill: 'rgba(0, 0, 0, 0.05)',
    },
    '& svg path': {
      fill: 'rgba(0, 0, 0, 0.05)',
    },
  }),
}))
